/** 使用者設定（字級等）—— localStorage 保存；`--font-scale` 套用到 <html>。*/
const FONT_SCALE_KEY = 'acc.fontScale';

export const FONT_SCALE_OPTIONS = [
  { id: 'std', scale: 1, labelKey: 'settings.font_std' },
  { id: 'lg', scale: 1.15, labelKey: 'settings.font_lg' },
  { id: 'xl', scale: 1.3, labelKey: 'settings.font_xl' },
] as const;

/** 預設字級（1 ＝ token 基準值，已經比原本大）*/
export const DEFAULT_FONT_SCALE = 1;

export function getFontScale(): number {
  const v = Number(localStorage.getItem(FONT_SCALE_KEY));
  return v > 0 ? v : DEFAULT_FONT_SCALE;
}

export function applyFontScale(scale: number): void {
  document.documentElement.style.setProperty('--font-scale', String(scale));
}

export function setFontScale(scale: number): void {
  localStorage.setItem(FONT_SCALE_KEY, String(scale));
  applyFontScale(scale);
}
